'use client';

import {
  BadgeDot,
  MENU_ACTIVE_ROW_CLASS,
  MENU_ROW_CLASS,
  MENU_SECTION_LABEL_CLASS,
} from '../../lib/header-constants';
import { getMegaMenuGroupDotColor } from '../../lib/mega-menu-badge';
import { cn } from '@/shared/utils/cn';
import { useNavbarContext } from './context';
import type { NavMegaMenuCategory, NavMegaMenuGroup } from '../../types/navigation';

interface HeaderMegaMenuCategoriesProps {
  activeGroupId?: string;
  categories: NavMegaMenuCategory[];
  groups: NavMegaMenuGroup[];
  onGroupChange: (groupId: string) => void;
}

const HeaderMegaMenuCategories = ({
  activeGroupId,
  categories,
  groups,
  onGroupChange,
}: HeaderMegaMenuCategoriesProps) => {
  const { onNavClick } = useNavbarContext();

  return (
    <aside className="border-adipa-border bg-adipa-surface-muted border-r px-2 py-3">
      <p className={cn(MENU_SECTION_LABEL_CLASS, 'pb-2')}>Explora</p>

      <ul className="space-y-0.5">
        {categories.map((category) => {
          if (!category.sectionId) {
            return category.href ? (
              <li key={category.label}>
                <a
                  className={cn('block', MENU_ROW_CLASS)}
                  href={category.href}
                  onClick={() =>
                    onNavClick?.({
                      href: category.href!,
                      label: category.label,
                      url: category.href!,
                    })
                  }
                >
                  {category.label}
                </a>
              </li>
            ) : null;
          }

          const isActive = activeGroupId === category.sectionId;
          const dotColor = getMegaMenuGroupDotColor(
            groups.find((group) => group.id === category.sectionId),
          );

          return (
            <li key={category.label}>
              <button
                aria-expanded={isActive}
                className={cn(
                  'flex items-center gap-2',
                  MENU_ROW_CLASS,
                  isActive && MENU_ACTIVE_ROW_CLASS,
                )}
                type="button"
                onClick={() => onGroupChange(category.sectionId!)}
                onFocus={() => onGroupChange(category.sectionId!)}
                onMouseEnter={() => onGroupChange(category.sectionId!)}
              >
                <span>{category.label}</span>
                {dotColor ? <BadgeDot color={dotColor} /> : null}
              </button>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default HeaderMegaMenuCategories;
